
import processQuerystring from '~/mixins/processQuerystring.js';

export default {
    name: "HappyKidsMobileSubcategory",
    mixins: [processQuerystring],
    props: {
        data: {
            type: Object,
            default: () => ({})
        },
        disclaimer: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

        }
    },
    computed: {
        displayProducts() {
            const product = this.$route.query.category ? this.data?.CoverageType.find(coverage => coverage?.Slug == this.$route.query.category) : this.data?.CoverageType.find(coverage => coverage?.Slug == this.$route.params.pathMatch)
            // const p = this.sortProductsByOrderNum(product.Products)
            // if (p.length > 0) {
            //     return p?.slice(
            //         (this.currentPage - 1) * this.perPage,
            //         (this.currentPage - 1) * this.perPage + this.perPage
            //     );
            // }

            return product.Products.slice(
                    (this.currentPage - 1) * this.perPage,
                    (this.currentPage - 1) * this.perPage + this.perPage
                );
        },
        displaySubcategories() {
            const currentSlug = this.$route.query.category ? this.$route.query.category : this.$route.params.pathMatch || this.$route.params.productSubcat;
            return this.data.CoverageType.map(item => ({
                icon: item?.IconType,
                isActive: item?.Slug === currentSlug,
                target: '_self',
                text: item?.Name,
                slug: item?.Slug

            }))
        },
        displayTitle() {
            return this.data?.Title;
        },
        displayDescription() {
            return this.data?.Description
        },
        total() {
            const product = this.data.CoverageType.find(coverage => coverage?.Slug === this.$route.query.category)
            return product?.Products?.length;
        },

        totalPage() {
            return Math.ceil(this.total / this.perPage);
        },

        currentPage: {
            get() {
                const value = this.$route.query.page || '1';
                return parseInt(value);
            },

            set(newValue) {
                this.updateQueryStringForCurrentPage(newValue);
                return newValue;
            },
        },
        perPage() {
            return 4;
        }
    },
    watch: {
        total() {
            this.$nextTick(() => {
                this.currentPage = 1;
            });
        },
    },
    methods: {
        updateQueryStringForCurrentPage(pageValue) {
            if (!this.$route.hash) {
                if (pageValue === 1) {
                    this.removeSingleQueryString('page');
                } else {
                    this.extendQueryString({ page: pageValue });
                }
            } else {
                if (pageValue === 1) {
                    this.removeSingleQueryStringWithHash(this.$route.hash, 'page');
                } else {
                    this.extendQueryStringWithHash(this.$route.hash, { page: pageValue })
                }
            }
        },
        togglePageChanged(obj) {
            this.currentPage = obj.pageValue;
        },
        // sortProductsByOrderNum(products) {
        //     try {
        //         const d = products.sort(() => Math.random() - 0.5)
        //         return d;
        //     } catch (error) {
        //         console.error('*** sortProductsByOrderNum error ***')
        //         if (!products) {
        //             console.error('products is null')
        //         }
        //         return null
        //     }
        // },
    },
}
